import React, { Fragment } from 'react';
import classNames from 'classnames';
import styles from './DeviceChartError.module.css';

function DeviceChartError({ retrying = false, classes }) {
  return (
    <div className={classNames(styles.root, classes?.errorRoot)}>
      <div className={styles.container}>
        <div className={styles.title}>Error</div>
        <div className={styles.message}>
          {retrying ? <DeviceChartRetryErrorMessage /> : <DeviceChartErrorMessage />}
        </div>
      </div>
    </div>
  );
}

export default DeviceChartError;

function DeviceChartErrorMessage() {
  return (
    <Fragment>
      Sorry, we are unable to complete your request. Please try it again later.
      <br />
      <br />
      <div>
        If the problem persists, please{' '}
        <a className={styles.link} href="mailto:support@pivotalcommware.com">
          contact us
        </a>
        <span>.</span>
      </div>
    </Fragment>
  );
}

function DeviceChartRetryErrorMessage() {
  return (
    <Fragment>
      We are having trouble with displaying the information at the moment. We will keep working on it
      <span className={styles.progress} />
    </Fragment>
  );
}
